var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 12.6414C4 11.5035 4.0078 11.1152 4.10012 10.7669C4.18883 10.4322 4.33483 10.1153 4.53165 9.8304C4.73645 9.53392 5.02655 9.2757 5.89151 8.53642L8.49151 6.3142C9.24111 5.67352 9.76148 5.22963 10.1962 4.91174C10.6208 4.60126 10.9049 4.45611 11.1626 4.3812C11.7096 4.22221 12.2904 4.22221 12.8374 4.3812C13.0951 4.45611 13.3792 4.60126 13.8038 4.91174C14.2385 5.22963 14.7589 5.67352 15.5085 6.3142L18.1085 8.53642C18.9734 9.2757 19.2636 9.53392 19.4683 9.8304C19.6652 10.1153 19.8112 10.4322 19.8999 10.7669C19.9922 11.1152 20 11.5035 20 12.6414V15.6C20 16.7366 19.9992 17.5289 19.9488 18.1458C19.8994 18.7509 19.8072 19.0986 19.673 19.362C19.3854 19.9265 18.9265 20.3854 18.362 20.673C18.0986 20.8072 17.7509 20.8994 17.1458 20.9488C16.5289 20.9992 15.7366 21 14.6 21H9.4C8.26339 21 7.47108 20.9992 6.85424 20.9488C6.24907 20.8994 5.90138 20.8072 5.63803 20.673C5.07354 20.3854 4.6146 19.9265 4.32698 19.362C4.19279 19.0986 4.10062 18.7509 4.05118 18.1458C4.00078 17.5289 4 16.7366 4 15.6V12.6414Z",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome2);
export default __webpack_public_path__ + "static/media/home2.065eb41e5d696a26600b0658b2a82cb3.svg";
export { ForwardRef as ReactComponent };